module.exports = "/_next/static/images/a261a1f14a423fa9af6f581860aa1983-card-background-left-xs.jpg.webp";